import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    prefix: 'tw:',
});
function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export { cn };
//# sourceMappingURL=utils.js.map
